import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import HoverFaqList from '../../../components/HomeSellingFaq/HoverFaqList';

// FAQ general de la home. Conserva su columna izquierda (título, subtítulo y
// CTA a /about); la lista de preguntas usa el MISMO componente y estilo que la
// FAQ comercial de arriba (HomeSellingFaq): tarjetas que abren al pasar el
// ratón, en una sola columna junto al texto. Antes era un acordeón Bootstrap
// (data-bs-toggle) con otro aspecto.
const QUESTION_COUNT = 4;

const HomeThreeFaq = () => {
   const { t } = useTranslation();

   const items = Array.from({ length: QUESTION_COUNT }, (_, i) => {
      const n = i + 1;
      return {
         key: `q${n}`,
         question: t(`home_faqs_questions_tileline_title_${n}`),
         answer: t(`home_faqs_questions_tileline_subtitle_${n}`),
      };
   });

   return (
      <>
         <section className="pb-200 pt-75">
            <div className="container">
               <div className="row">
                  <div className="col-xl-4 col-lg-5 col-md-5">
                     <div className="faq__content">
                        <div className="section-title mb-45">
                           <h2>{t("home_faqs_questions_title_superior_1")}<br/>{t("home_faqs_questions_title_superior_2")}</h2>
                           <p>{t("home_faqs_questions_title_inferior_2")}</p>
                        </div>
                        <Link to="/about" className="z-btn z-btn-border">{t("home_faqs_questions_button")}</Link>
                     </div>
                  </div>
                  <div className="col-xl-6 col-lg-6 col-md-7 offset-xl-2 offset-lg-1">
                     <div className="hsf__aside-list">
                        <HoverFaqList items={items} columns={1} idPrefix="hsf-home" />
                     </div>
                  </div>
               </div>
            </div>
         </section>
      </>
   );
};

export default HomeThreeFaq;
